export const environment = {
  "isProd": false,
  //"production": "https://api.nutrimind.online/v1/",
  "production": "https://api.nutrimind.game.nbt.expert/v1/",

  // TODO зміна для ховання показання контенту (production и development, 
  // и если переменная production - НЕ показывать описанные ниже элементы, если переменная development - показывать.)
  "isProduction": "development", // production, development

  // TODO DELETE
  //"linkCabinetRegistration": "https://my.nutrimind.online/ru/login",
  "linkCabinetRegistration": "https://my.nutrimind.game.nbt.expert/ru/login",
  // "pdfProd": "https://my.nutrimind.online/rules/rules_of_the_game.pdf",
  "pdfFile": "https:///my.nutrimind.game.nbt.expert/rules/rules_of_the_game.pdf",
  "game":"https://play.nutrimind.game.nbt.expert",
  //"prod":"https://play.nutrimind.online",
  
  // "linkCabinet": "https://my.nutrimind.online/",
  "linkCabinet": "https://my.nutrimind.game.nbt.expert/",

  "linkLending":"https://nutrimind.game.nbt.expert/",
  
  // TODO ADD
  "linkSignUp": "signup",
  "linkLogin": "login",

  //TODO settings fields
  "settings_play_field" : {
		"type": "circle",
		"count_field": 45,
		"sector_breakdown" : false,
		"skip_move": true,
		"fast_movement": false,
		"number_of_cubes": 1
	},
	//totdo db prod
	// firebaseConfig : { projectId: "nutri-mind-23805", appId: "1:39506681060:web:4cad8c3b3373cdc60720f1", databaseURL: "https://nutri-mind-23805-default-rtdb.europe-west1.firebasedatabase.app", storageBucket: "nutri-mind-23805.firebasestorage.app", apiKey: "AIzaSyDFDEvoGytSziJ405dXlJu3flkCSqQ1C6o", authDomain: "nutri-mind-23805.firebaseapp.com", messagingSenderId: "39506681060" }
 // todo db dev
  firebaseConfig : {
    databaseURL:"https://my-test-nutri-mind-default-rtdb.europe-west1.firebasedatabase.app",
    apiKey: "AIzaSyDLhYMDsFOxmBesd8LJFODc8cqC45obrQU",
    authDomain: "my-test-nutri-mind.firebaseapp.com",
    projectId: "my-test-nutri-mind",
    storageBucket: "my-test-nutri-mind.firebasestorage.app",
    messagingSenderId: "804834148349",
    appId: "1:804834148349:web:31bf592dd0648f8998e394",
    measurementId: "G-PE01MDWVBY"
  }
}